export const ASSET_ROUTES = {
  HARDWARE: '/hardware/overview/' as const,
  WORKSTATIONS: '/hardware/workstations/' as const,
  LICENSING: '/licenses/overview/' as const,
};
